import React, {useState, useContext} from 'react';
import {useQueryClient} from 'react-query';
import {FormGroup, FormControl, Grid, CardMedia, Button, useTheme, IconButton, Tooltip} from "@material-ui/core";
import moment from "moment";
import __ from "lodash";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import {AssignmentTurnedIn, DeleteOutline, PageviewOutlined} from "@material-ui/icons";
import SystemContext from "../../../SystemContext";
import {getApiSitePrefix} from "../../../functions/SiteDefaults";
import {
  MaskedText,
  FormSelect,
  Form,
  LabelledPaper,
  FormCheckbox,
  ComboSelect,
  DatePicker,
  DropzoneFileUpload
} from '../../../controls';
import ExchangeRateProviderSelector from "../../Currencies/components/ExchangeRateProviderSelector";
import CurrencySelector from "../../Currencies/components/CurrencySelector";
import CompanyValidator from "../validators/CompaniesValidator";
import { useUpdateCompany } from "../../../services/companies";
import DocumentViewer from "../../Documents/DocumentViewer";

const apiSitePrefix = getApiSitePrefix();
const dateFormat = "DD/MM/YYYY";


const CompanyDetailsForm = (_props) => {
  const props = {
    canEdit: false,
    ..._props
  }
  const SystemData = useContext(SystemContext);
  const theme = useTheme();

  const fuelOrderProcessTypes = [];
  SystemData.fuelOrderProcess.map(type => {
    fuelOrderProcessTypes.push({code: type, value: type});
  });

  const classes = props.classes;

  const [state,setState] = useState({showDocumentViewer: false, documentsToView: []});
  const [record, setRecord] = useState(props.record);
  const [editing, setEditing] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    severity: "error",
    message: ""
  });

  // if ((props.record && !record) || (!props.record && record) || (props.record && record && props.record.companyUuid !== record.companyUuid) ) {
  //   setRecord(props.record);
  //   setEditing(false);
  // }

  const eventBus = SystemData.eventBus;
  if (eventBus) {
    eventBus.bind('CompanyManagementList.rowSelected', (record)=> {
      const termsDocument = record.termsDocument;
      const documentData = termsDocument && Array.isArray(termsDocument) && termsDocument.length > 0 ? termsDocument[0] : null;
      setRecord({...record, termsFileName: documentData?.fileName ?? ""});
      setEditing(false);
    });
  }

  const queryClient = useQueryClient();
  const extraKeys = [];
  const handleUpdateCompany = useUpdateCompany();

  const formatChars={
    "U": "[A-Z]",
    "A": "[A-Z0-9]",
    "a": "[A-Za-z0-9]",
    "9": "[0-9]",
    "D": "[0-9.]",
    "-": "-",
    "x": "."
  }

  const getKycDetails = async (SystemData, companyUuid, changeRecord, pioneerAccountId) => {
debugger;
    try {
      SystemData.toggleLoadingProgress(true, `Checking Know Your Customer Status ...`);
      const response = await axios.get(`${apiSitePrefix}/companies/getKycStatus/${companyUuid}/${pioneerAccountId}`);
      SystemData.toggleLoadingProgress(false);
      if (response.data && response.data.success && __.has(response.data, "comment")) {
        const message = response.data.comment;
        if (changeRecord && __.has(response.data, "companyKycData")) {
          changeRecord({
            pioneerAccountId: pioneerAccountId,
            kycStatusCode: response.data.companyKycData.kycStatusCode,
            kycExpiryDate: response.data.companyKycData.kycExpiryDate,
            kycDocumentStatus: response.data.companyKycData.kycDocumentStatus
          });
        }
        SystemData.alert("KYC Status Update", message);
        queryClient.invalidateQueries(["Companies"]);
      }

      if (!response.data) {
        const message = `Could not retrieve KYC data. Server is not responding`;
        console.log(message);
        SystemData.alert("Error", message);
      } else if (!response.data.success) {
        const message = `Could not retrieve KYC data. Server returned ${response.data.error}`;
        console.log(message);
        SystemData.alert("Error", message);
      }
    } catch (err) {
      SystemData.toggleLoadingProgress(false);
      const message = `Could not retrieve KYC data. Server is not responding`;
      console.log(message);
      SystemData.alert("Error", message);
    }

    return null;
  }


  return (
    <div key="formContainer" style={{width: "100%", textAlign:"left"}}>
      {record ?
        <Form
          key="form"
            title={(record)=>{return `Company Details for ${record.companyName}`}}
            message=""
            open={true}
            record={record}
            validator={editing?CompanyValidator:null}
            top={"calc(100vh - 275px)"}
            formTitleStyle={{padding: "16px 16px"}}
            titleBarStyle={{backgroundColor: '#3f3f3f', color: theme.palette.primary.main, padding: "6px"}}
            formBodyStyle={{maxHeight: "calc(100vh - 350px)"}}
            buttonBarStyle={{width: "calc(100% - 20px)"}}
            buttons = {editing?
              {
                save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
                cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
              }: props.canEdit?{
                edit: {icon: "edit", key: "Edit", label: "Edit", color: "primary"}
              }: {}
            }

            // validator={AddTripValidator}
            onChange={(state) => {
              if (state.buttonPressed === "edit" && props.canEdit) {
                setEditing(true);
              }
              if (state.buttonPressed === "cancel") {
                setEditing(false);
                setRecord(props.record);
              }
              if (state.buttonPressed === "save") {
                SystemData.toggleLoadingProgress(true);
                const record = state.record;
                handleUpdateCompany.mutate({
                  extraKeys,
                  record,
                  postSuccess: () => {
                    setEditing(false);
                    SystemData.toggleLoadingProgress(false);
                    setAlert({ severity: "info", open: true, message: "Record Updated", timeOut: 5 });
                  },
                  postError: (data) => {
                    SystemData.toggleLoadingProgress(false);
                    if (data.errorMessage) {
                      SystemData.alert("Error", `${data.errorMessage}`);
                    } else {
                      SystemData.alert("Error", `An Unexpected Error has occurred updating the Company record.`);
                    }
                  }
                });
              } else {
              }
            }}
        >

          <Grid container checkChildren={true} spacing={3}>

            <Grid item xs={12} checkChildren={true}>
              <LabelledPaper checkChildren={true} label="Company Classification">
                <FormControl checkChildren={true} key="FC-classification">
                  <FormGroup checkChildren={true} key="FG-classification" row>
                    <FormCheckbox
                      id="isGsa"
                      key="isGsa"
                      label="Sales Agent"
                      className={classes.checkbox}
                      readOnly={editing!==true}
                      checked={record.isClient}
                    />
                    <FormCheckbox
                      id="isClient"
                      key="isClient"
                      label="Client"
                      className={classes.checkbox}
                      readOnly={editing!==true}
                      checked={record.isClient}
                    />
                    <FormCheckbox
                      id="isSupplier"
                      key="isSupplier"
                      label="Supplier"
                      className={classes.checkbox}
                      readOnly={editing!==true}
                      checked={record.isSupplier}
                    />
                    <FormCheckbox
                      id="isFuelSupplier"
                      key="isFuelSupplier"
                      label="Fuel Supplier"
                      className={classes.checkbox}
                      readOnly={editing!==true}
                      checked={record.isSupplier}
                    />
                    <FormCheckbox
                      id="isPermitSupplier"
                      key="isPermitSupplier"
                      label="Permit Supplier"
                      className={classes.checkbox}
                      readOnly={editing!==true}
                      checked={record.isPermitSupplier}
                    />
                    <FormCheckbox
                      id="isGha"
                      key="isGha"
                      label="Ground Handler"
                      className={classes.checkbox}
                      readOnly={editing!==true}
                      checked={record.isGha}
                    />
                    <FormCheckbox
                      id="isCgha"
                      key="isCgha"
                      label="Cargo Handler"
                      className={classes.checkbox}
                      readOnly={editing!==true}
                      checked={record.isCgha}
                    />
                    <FormCheckbox
                      id="isAirline"
                      key="isAirline"
                      label="Airline"
                      className={classes.checkbox}
                      readOnly={editing!==true}
                      checked={record.isAirline}
                    />
                    <FormCheckbox
                      id="isShipper"
                      key="isShipper"
                      label="Shipper"
                      className={classes.checkbox}
                      readOnly={editing!==true}
                      checked={record.isShipper}
                    />
                    <FormCheckbox
                      id="isConsignee"
                      key="isConsignee"
                      label="Consignee"
                      className={classes.checkbox}
                      readOnly={editing!==true}
                      checked={record.isConsignee}
                    />
                  </FormGroup>
                </FormControl>
              </LabelledPaper>
            </Grid>

            <Grid item xs={12} checkChildren={true}/>
            <Grid item xs={6} checkChildren={true}>
              <MaskedText
                id="companyName"
                label="Company Name"
                readOnly={editing!==true}
                fullWidth
                mask={"x".repeat(100)}
                maskChar={""}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            </Grid>
            <Grid item xs={3} checkChildren={true}>
              <MaskedText
                id="companyCode"
                label="Company Code"
                readOnly={editing!==true}
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"A".repeat(20)}
                maskChar={""}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            </Grid>
            <Grid item xs={3} checkChildren={true}>
              <MaskedText
                id="branchCode"
                label="Branch Code"
                readOnly={editing!==true}
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"a".repeat(20)}
                maskChar={""}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            </Grid>

            {(record) => (
              record.isAirline
                ?
                  <Grid container checkChildren={true} spacing={3} style={{marginLeft: 2}}>
                    <Grid item xs={12} checkChildren={true}/>
                    <Grid item xs={3} checkChildren={true}>
                      <MaskedText
                        id="airlineCode"
                        label="IATA Airline Code"
                        readOnly={editing!==true}
                        inputLabelProps={{shrink: true}}
                        fullWidth
                        mask={"A".repeat(2)}
                        maskChar={""}
                        alwaysShowMask={false}
                        formatChars={formatChars}
                      />
                    </Grid>
                    <Grid item xs={3} checkChildren={true}>
                      <MaskedText
                        id="airlineCodeIcao"
                        label="ICAO Airline Code"
                        readOnly={editing!==true}
                        inputLabelProps={{shrink: true}}
                        fullWidth
                        mask={"A".repeat(3)}
                        maskChar={""}
                        alwaysShowMask={false}
                        formatChars={formatChars}
                      />
                    </Grid>
                    <Grid item xs={3} checkChildren={true}>
                      <ComboSelect
                        id="flightScheduleFormat"
                        label="Flight Schedule Format"
                        group="FLIGHT SCHEDULE"
                        subGroup="FORMAT"
                        inputLabelProps={{ shrink: true }}
                        readOnly={editing!==true}
                        //style={{marginTop:1}}
                        onChange={(value, props) => {
                          if (value) {
                            const flightScheduleFormat = value;
                            const data = {
                              flightScheduleFormat: flightScheduleFormat
                            }
                            props.recordChange(data);
                          } else {
                            props.onChange(value);
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                :
                  <></>
              )
            }
            <Grid item xs={12} checkChildren={true}/>
            <Grid item xs={3} checkChildren={true}>
              <MaskedText
                id="mcsCode"
                label="MCS Code"
                readOnly={editing!==true}
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"A".repeat(50)}
                maskChar={""}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            </Grid>
            <Grid item xs={3} checkChildren={true}>
              <ComboSelect
                id="contractType"
                label="Contract Type"
                group="CONTRACT TYPE"
                subGroup=""
                inputLabelProps={{ shrink: true }}
                readOnly={editing!==true}
                //style={{marginTop:1}}
              />
            </Grid>

            <Grid item xs={3} checkChildren={true}>
              <ExchangeRateProviderSelector
                id="exchangeRateType"
                label="Rate Provider"
                inputProps={{readOnly:editing!==true}}
                readOnly={editing!==true}
                shrink
                fullWidth
                type={"SYSTEM"}
                onChange={(returnObject, props) => {
                  if (returnObject.found) {
                    const supplier = returnObject.data
                    const data = {
                      companyName: supplier.companyName,
                      companyUuid: supplier.companyUuid,
                    }
                    props.recordChange(data);
                  } else {
                    props.onChange(returnObject.value);
                  }
                }}
              />
            </Grid>
            <Grid item xs={3} checkChildren={true}>
              <CurrencySelector
                id="defaultCurrencyCode"
                label="Default Currency"
                inputProps={{readOnly:editing!==true}}
                readOnly={editing!==true}
                shrink
                fullWidth
                style={{marginTop:0, marginLeft: 0}}
                onChange={(value, props) => {
                  props.onChange(value);
                }}
              />
            </Grid>

            {/*Addresses*/}
            <Grid item xs={12} checkChildren={true}/>
            <Grid item xs={3} checkChildren={true}>
              <MaskedText
                id="iataAgentCode"
                label="IATA Agent Code"
                readOnly={editing!==true}
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"9".repeat(7)}
                maskChar={""}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            </Grid>
            <Grid item xs={3} checkChildren={true}>
              <MaskedText
                id="cassAddress"
                label="CASS Address"
                readOnly={editing!==true}
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"9".repeat(4)}
                maskChar={""}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            </Grid>
            <Grid item xs={3} checkChildren={true}>
              <MaskedText
                id="accountNumber"
                label="Account Number"
                readOnly={editing!==true}
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"A".repeat(14)}
                maskChar={""}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            </Grid>
            <Grid item xs={3} checkChildren={true}>
              <MaskedText
                id="participantCode"
                label="Participant Code"
                readOnly={editing!==true}
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"A".repeat(17)}
                maskChar={""}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            </Grid>

            <Grid item xs={12} checkChildren={true}/>
            <Grid item xs={3} checkChildren={true}>
              {record=> (record.isFuelSupplier
                ?
                  <FormSelect
                    id="fuelOrderProcess"
                    label="Fuel Order Process"
                    options={fuelOrderProcessTypes ? fuelOrderProcessTypes : null}
                    readOnly={editing!==true}
                    fullWidth
                  />
                :
                  <></>
                )
              }
            </Grid>

            <Grid item xs={12} checkChildren={true}>
              <LabelledPaper checkChildren={true} label="Know Your Customer Classification">
                <Grid container checkChildren={true} spacing={3}>
                  <Grid item xs={2} />
                  <Grid item xs={12} />
                  {(record) => {
                    let verified = false;
                    if (record?.pioneerAccountId && record?.kycStatusCode && record?.kycExpiryDate) {
                      if ([123340000, 418390003, 123340002, 418390002].includes(Number(record?.kycStatusCode))) {
                        const expired = moment(record.kycExpiryDate).isBefore(moment());
                        if (!expired)
                          verified = true;
                      }
                    }
                    return (
                      <Grid item xs={1} checkChildren={true}>
                        <CardMedia
                          component="img"
                          alt={"KycUnverified"}
                          style={{height: 100, width:150}}
                          image={ verified ? "images/KycVerified.png" : "images/KycUnverified.png"}
                        />
                      </Grid>
                    )
                  }}
                  <Grid item xs={1}/>
                  <Grid item xs={3} checkChildren={true}>
                    <div style={{display: 'inline-flex', width: "100%"}}>
                      <MaskedText
                        id="pioneerAccountId"
                        label="Pioneer Account ID"
                        readOnly={editing!==true}
                        inputLabelProps={{shrink: true}}
                        fullWidth
                        mask={"xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"}
                        maskChar={""}
                        alwaysShowMask={false}
                        formatChars={formatChars}
                        onChange={(value, props) => {
                          if (value) {
                            const pioneerAccountId = value
                            const data = {
                              pioneerAccountId: pioneerAccountId
                            }
                            props.recordChange(data);
                          } else {
                            props.onChange(value);
                          }
                        }}
                      />
                      {(record, changeRecord) =>
                        <Tooltip id="getKycDetails" title={"Update KYC Status"}>
                          <IconButton
                            color="secondary"
                            onClick={() => {
                              document.getElementById("getKycDetails").focus();
                              getKycDetails(SystemData, record.companyUuid, changeRecord, record.pioneerAccountId);
                            }}
                            disabled={editing !==true || record.pioneerAccountId === null}
                          >
                            <AssignmentTurnedIn style={{height: 32, width: 32, }} color={editing!==true || record.pioneerAccountId === null ? "disabled" : "primary"}/>
                          </IconButton>
                        </Tooltip>
                      }
                    </div>
                  </Grid>
                  <Grid item xs={2} checkChildren={true}>
                    <ComboSelect
                      id="kycStatusCode"
                      label="KYC Status"
                      group="KYC"
                      subGroup=""
                      inputLabelProps={{ shrink: true }}
                      readOnly={editing!==true}
                      //style={{marginTop:1}}
                      onChange={(value, props) => {
                        if (value) {
                          const kycStatusCode = value;
                          const data = {
                            kycStatusCode: kycStatusCode
                          }
                          props.recordChange(data);
                        } else {
                          props.onChange(value);
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={2} checkChildren={true}>
                    <ComboSelect
                      id="kycDocumentStatus"
                      label="KYC Document Status"
                      group="KYC"
                      subGroup="DOC STATUS"
                      inputLabelProps={{ shrink: true }}
                      readOnly={editing!==true}
                      //style={{marginTop:1}}
                      onChange={(value, props) => {
                        if (value) {
                          const kycDocumentStatus = value;
                          const data = {
                            kycDocumentStatus: kycDocumentStatus
                          }
                          props.recordChange(data);
                        } else {
                          props.onChange(value);
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={3} checkChildren={true}>
                    <DatePicker
                      id="kycExpiryDate"
                      label="Expiry Date"
                      disableToolbar={true}
                      autoOk={true}
                      format={dateFormat}
                      readOnly={editing!==true}
                      onChange={(value, props) => {
                        if (value) {
                          const kycExpiryDate = value
                          const data = {
                            kycExpiryDate: kycExpiryDate
                          }
                          props.recordChange(data);
                        } else {
                          props.onChange(value);
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </LabelledPaper>
            </Grid>

            <Grid item xs={12} checkChildren={false}/>

            <Grid item xs={12} checkChildren={true}>
              <LabelledPaper checkChildren={true} label="Terms & Conditions">
                <Grid container checkChildren={true} spacing={3}>
                  <Grid item xs={2} checkChildren={true}>
                    <FormCheckbox
                      id="termsAgreed"
                      key="termsAgreed"
                      label="Terms Agreed"
                      className={classes.checkbox}
                      readOnly={editing!==true}
                      checked={record.termsAgreed}
                    />
                  </Grid>

                  <Grid item xs={3} checkChildren={true}>
                    {(record) => {
                      return (
                        <MaskedText
                          id="termsFileName"
                          label="Terms Document"
                          readOnly={true}
                          inputLabelProps={{shrink: true}}
                          fullWidth
                          mask={"x".repeat(250)}
                          maskChar={""}
                          alwaysShowMask={false}
                          formatChars={formatChars}
                        />
                      )}
                    }
                  </Grid>

                  <Grid item xs={5} checkChildren={true}>
                    <div style={{marginTop: 6}}>
                      {(record) => {
                        return (
                          <DropzoneFileUpload
                            objectType={"GENERAL"}
                            objectUuid={record.companyUuid || uuidv4()}
                            documentUuid={record.companyUuid || uuidv4()}
                            accept=".doc, .docx, .xls, .xlsx, .jpg, .png, .pdf"
                            dropzoneStyle={{height: 38, maxHeight: 38, minHeight: 38, border: "1px dashed #929292"}}
                            inputLabel={{fontSize: 17, color: "#fd5b02"}}
                            inputContent={`Drop Terms & Conditions file or Click to browse`}
                            disabled={editing !== true}
                            onChange={(result, props) => {
                              if (result && result.status) {
                                const fileType = result.fileName.split('.');
                                const fileSize = result.fileSize > 1000000
                                  ? `${(result.fileSize / 1000000).toFixed(0)}MB`
                                  : result.fileSize > 1000
                                    ? `${(result.fileSize / 1000).toFixed(0)}KB`
                                    : `${result.fileSize}B`
                                const termsDocument = {
                                  documentType: "GENERAL",
                                  fileName: result.fileName,
                                  fileType: Array.isArray(fileType) && fileType.length > 1 ? fileType[fileType.length - 1] : "",
                                  fileUrl: result.url
                                }
                                props.recordChange({...props.record, termsDocument: [termsDocument], termsFileName: result.fileName});
                              }
                            }}
                          />
                        );
                      }}
                    </div>

                  </Grid>
                  <Grid item xs={2} checkChildren={true}>
                    {(record) => (
                      <Button
                        style={{height:24, marginTop: 12}}
                        variant="text"
                        color="primary"
                        // disabled={gridApi && gridApi.getModel().rowsToDisplay.length === 0}
                        startIcon={<PageviewOutlined/>}
                        //className={classes.button}
                        onClick={()=>{
                          let documentsToView = [];
                          const termsDocument = record?.termsDocument;
                          const documentData = termsDocument && Array.isArray(termsDocument) ? termsDocument : null;
                          if(documentData){
                            documentData.forEach( row => {
                              if (__.has(row, "fileUrl") && row.fileUrl !== "") {
                                const document = {
                                  documentType: row.documentType,
                                  documentDescription: row.fileDescription,
                                  fileName: row.fileName,
                                  fileType: row.fileType,
                                  uri: row.fileUrl
                                }
                                documentsToView.push(document);
                              }
                            });
                          }
                          if (documentsToView.length < 1) {
                            SystemData.alert("", `There are no documents with valid files attached to view`);
                            return;
                          }
                          setState({...state, showDocumentViewer: true, documentsToView})
                        }}
                      >
                        {`View`}
                      </Button>
                    )}
                  </Grid>
                  <Grid item xs={12} />
                </Grid>
              </LabelledPaper>
            </Grid>

          </Grid>
        </Form>
        :<></>
      }
      {state.showDocumentViewer
        ?
          <DocumentViewer
            dialogStates=
              {
                {showDialog: state.showDocumentViewer,
                  title: `Documents Viewer`,
                  record: state.documentsToView[0]
                }
              }
            close={()=>{setState({...state, showDocumentViewer: false})}}
            documents={state.documentsToView}
          />
        :
          <></>
      }
    </div>
  );
}

export default CompanyDetailsForm;
